import {
  Stack,
  Box,
  Text,
  PopoverRenderer,
  TextLink,
  IconBolt,
  Button
} from '@machobear/design-system'
import { Userpilot } from 'userpilot'
import React from 'react'
import { useTranslation } from 'react-i18next'
import config from '@/config'

const userPilotClickIds = {
  first_tenant_message_received: 'first_msg_received',
  every_tenant_message_received_5_minutes: 'every_tenant_msg',
  first_tenant_message_received_for_the_day: 'first_msg_day',
  application_received: 'application_received',
  invited_to_apply: 'invite_to_apply',
  new_contract_fully_signed: 'contract_signed',
  unit_has_been_rented: 'unit_rented',
  tenant_application_copied: 'application_copied'
}

type PopoverUpgradeProps = {
  hasButton?: boolean
  fullWidth?: boolean
  trackingId: string
}

const { WEB_URL } = config

const PopoverUpgrade = ({
  fullWidth = false,
  hasButton = false,
  trackingId
}: PopoverUpgradeProps) => {
  const { t } = useTranslation()
  return (
    <PopoverRenderer
      trigger={({ triggerProps }) => (
        <Box display={'flex'} alignItems={'center'} {...triggerProps}>
          <Box
            background="promoteLight"
            borderRadius="small"
            padding="xxxsmall"
            marginRight={'xxsmall'}
          >
            <IconBolt tone="promote" />
          </Box>
          {hasButton && (
            <Box width={fullWidth ? 'full' : undefined}>
              <Button size="small" variant={'solid'} disabled={true}>
                {t('l.settings.view.auto_reply.add_auto_reply', 'Add Auto Reply')}
              </Button>
            </Box>
          )}
        </Box>
      )}
    >
      {({ close }) => (
        <Box marginBottom="xsmall">
          <Stack space="xxxsmall">
            <Text size="small">
              {t(
                'l.settings.view.auto_reply.popover',
                'Need more Auto-Replies? Upgrade to a Growth or Business Plan to unlock unlimited access'
              )}
            </Text>
            <Box marginTop={'small'}>
              <Text size="small" weight="strong">
                <TextLink
                  onClick={() => {
                    if (trackingId && trackingId in userPilotClickIds) {
                      const userPilotKey = `settings_autoreply_click_${userPilotClickIds[trackingId as keyof typeof userPilotClickIds]}_upgradeaccount_anchortxt`
                      Userpilot.track(userPilotKey)
                    }
                  }}
                  href={`${WEB_URL}/pricing`}
                  target="_blank"
                  color="white"
                >
                  {t('l.settings.view.auto_reply.upgrade_now', 'Upgrade Now')}
                </TextLink>
              </Text>
            </Box>
          </Stack>
        </Box>
      )}
    </PopoverRenderer>
  )
}

export default PopoverUpgrade
